/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// Input search
document.addEventListener('input', function () {
  const input = document.querySelector('.keyword-search');

  // Return if no element
  if (!input) {
    return;
  }

  const inpValue = input.value.trim();
  if (inpValue) {
    input.classList.add('is-filled');
    searchFunction(input);
  } else {
    input.classList.remove('is-filled');
  }
});

// Search Filter
function searchFunction(input) {
  var filter, ul, li, a, i, txtValue;
  filter = input.value.toUpperCase();
  ul = document.querySelectorAll(".facet-filter-filter-p-tag")[0];
  li = ul.querySelectorAll(".checkbox-container");

  for (i = 0; i < li.length; i++) {
    a = li[i].querySelectorAll("label")[0];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}

// Custom Drawer
var CustomDrawerContent = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback();

    if (!this.classList.contains("custom-drawer")) {
      this.classList.add("custom-drawer");
    }

    if (this.hasAttribute("reverse-breakpoint")) {
      this.originalDirection = this.classList.contains("drawer--from-left") ? "left" : "right";
      const matchMedia2 = window.matchMedia(this.getAttribute("reverse-breakpoint"));
      matchMedia2.addListener(this._checkReverseOpeningDirection.bind(this));
      this._checkReverseOpeningDirection(matchMedia2);
    }
    this.rootDelegate.on("click", ".drawer__overlay", () => this.open = false);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        document.documentElement.classList.toggle("lock-all", this.open);
    }
  }
  _checkReverseOpeningDirection(match) {
    this.classList.remove("drawer--from-left");
    if (this.originalDirection === "left" && !match.matches || this.originalDirection !== "left" && match.matches) {
      this.classList.add("drawer--from-left");
    }
  }
};
window.customElements.define("custom-drawer-content", CustomDrawerContent);

//Header Overlay

var CustomPredictiveSearchDrawer = class extends CustomDrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.inputElement = document.getElementById('custom-search-input');
    this.drawerContentElement = this.querySelector(".custom-drawer__dropdown");
    this.drawerFooterElement = this.querySelector(".custom-drawer__footer");
    this.loadingStateElement = this.querySelector(".predictive-search__loading-state");
    this.resultsElement = this.querySelector(".predictive-search__results");
    this.menuListElement = this.querySelector(".predictive-search__menu-list");
    // this.delegate.on("input", '[name="q"]', this._debounce(this._onSearch.bind(this), 200));
    this.delegate.on("click", '[data-action="reset-search"]', this._startNewSearch.bind(this));
    this.delegate.on("click", '.custom-drawer__cart-icon', this._closeDrawer.bind(this));

    // Implement value to this.inputElement and trigger search
    document.getElementById('custom-search-input').addEventListener("input", (event) => {
      this._debounce(this._onSearch(event, event.target), 200)
    });
  }
  async _onSearch(event, target) {
    if (event.key === "Enter") {
      return;
    }
    if (this.abortController) {
      this.abortController.abort();
    }
    this.drawerContentElement.classList.remove("drawer__content--center");
    this.drawerFooterElement.hidden = true;
    const targetVal = target.value.trim();
    if (targetVal === "") {
      this.classList.add("hidden");
      this.loadingStateElement.hidden = true;
      this.resultsElement.hidden = true;
      this.menuListElement ? this.menuListElement.hidden = false : "";
    } else {
      this.classList.remove("hidden");
      this.drawerContentElement.classList.add("drawer__content--center");
      this.loadingStateElement.hidden = false;
      this.resultsElement.hidden = true;
      this.menuListElement ? this.menuListElement.hidden = true : "";
      let searchResults = {};
      try {
        this.abortController = new AbortController();
        if (this._supportPredictiveApi()) {
          searchResults = await this._doPredictiveSearch(targetVal);
        } else {
          searchResults = await this._doLiquidSearch(targetVal);
        }
      } catch (e) {
        if (e.name === "AbortError") {
          return;
        }
      }
      this.loadingStateElement.hidden = true;
      this.resultsElement.hidden = false;
      this.menuListElement ? this.menuListElement.hidden = true : "";
      if (searchResults.hasResults) {
        this.drawerFooterElement.hidden = false;
        this.drawerContentElement.classList.remove("drawer__content--center");
      }
      this.resultsElement.innerHTML = searchResults.html;
    }
  }
  async _doPredictiveSearch(term) {
    const response = await fetch(`${window.themeVariables.routes.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`, {
      signal: this.abortController.signal
    });
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
  }
  /* Some languages do not support predictive search API so we fallback to the Liquid search */
  async _doLiquidSearch(term) {
    const response = await fetch(`${window.themeVariables.routes.searchUrl}?q=${encodeURIComponent(term)}&resources[limit]=50&section_id=predictive-search-compatibility`, {
      signal: this.abortController.signal
    });
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
  }
  _startNewSearch() {
    this.inputElement.value = "";
    this.inputElement.focus();
    const event = new Event("input", {
      bubbles: true,
      cancelable: true
    });
    this.inputElement.dispatchEvent(event);
  }
  _supportPredictiveApi() {
    const shopifyFeatureRequests = JSON.parse(document.getElementById("shopify-features").innerHTML);
    return shopifyFeatureRequests["predictiveSearch"];
  }
  _closeDrawer() {
    this.open = false;
  }
  /**
   * Simple function that allows to debounce
   */
  _debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
};
window.customElements.define("custom-predictive-search-drawer", CustomPredictiveSearchDrawer);

// js/custom-element/section/search/predictive-search-input.js
var PredictiveSearchInput = class extends HTMLInputElement {
  connectedCallback() {
    this.addEventListener("input", () => {
      document.getElementById(this.getAttribute("aria-controls")).open = true;
    });
  }
};
window.customElements.define("predictive-search-input-drawer", PredictiveSearchInput, { extends: "input" });


// Custom Cart Drawer
var CustomCartDrawer = class extends CustomDrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.nextReplacementDelay = 0;
    this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this));
    this.addEventListener("variant:added", () => this.nextReplacementDelay = 600);
  }
  async _rerenderCart(event) {
    let cartContent = null, html = "";
    if (event.detail && event.detail["cart"] && event.detail["cart"]["sections"]) {
      cartContent = event.detail["cart"];
      html = event.detail["cart"]["sections"]["mini-cart"];
    } else {
      const response = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${this.getAttribute("section")}`);
      html = await response.text();
    }
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = html;
    setTimeout(async () => {
      const previousPosition = this.querySelector(".drawer__content").scrollTop;
      this.innerHTML = fakeDiv.querySelector("custom-cart-drawer").innerHTML;
      if (cartContent && cartContent["item_count"] === 0) {
        this.querySelector(".drawer__content").animate({ opacity: [0, 1], transform: ["translateY(40px)", "translateY(0)"] }, { duration: 450, easing: "cubic-bezier(0.33, 1, 0.68, 1)" });
      } else {
        this.querySelector(".drawer__content").scrollTop = previousPosition;
      }
      if (event?.detail?.openMiniCart) {
        this.clientWidth;
        this.open = true;
      }
    }, event?.detail?.replacementDelay || this.nextReplacementDelay);
    this.nextReplacementDelay = 0;
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        if (this.open) {
          this.querySelector(".drawer__content").scrollTop = 0;
          if (!MediaFeatures.prefersReducedMotion()) {
            const lineItems = Array.from(this.querySelectorAll(".line-item")), recommendationsInner = this.querySelector(".mini-cart__recommendations-inner"), bottomBar = this.querySelector(".drawer__footer"), effects = [];
            if (recommendationsInner && window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
              lineItems.push(recommendationsInner);
            }
            lineItems.forEach((item) => item.style.opacity = 0);
            recommendationsInner ? recommendationsInner.style.opacity = 0 : null;
            effects.push(new ParallelEffect(lineItems.map((item, index) => {
              return new CustomKeyframeEffect(item, {
                opacity: [0, 1],
                transform: ["translateX(40px)", "translateX(0)"]
              }, {
                duration: 400,
                delay: 400 + 120 * index - Math.min(2 * index * index, 120 * index),
                easing: "cubic-bezier(0.25, 1, 0.5, 1)"
              });
            })));
            if (recommendationsInner && !window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
              effects.push(new CustomKeyframeEffect(recommendationsInner, {
                opacity: [0, 1],
                transform: ["translateX(100%)", "translateX(0)"]
              }, {
                duration: 250,
                delay: 400 + Math.max(120 * lineItems.length - 25 * lineItems.length, 25),
                easing: "cubic-bezier(0.25, 1, 0.5, 1)"
              }));
            }
            let animation = new CustomAnimation(new ParallelEffect(effects));
            animation.play();
          }
        }
    }
  }
};
window.customElements.define("custom-cart-drawer", CustomCartDrawer);

// js/custom-element/behavior/toggle-link.js
var BounceToggleLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.controlledElement.open = true;
    });
  }
  get controlledElement() {
    return document.querySelector(`#${this.getAttribute("aria-controls")}`);
  }
};
window.customElements.define("bounce-toggle-link", BounceToggleLink, { extends: "a" });

// Listening for the "pagination:page-changed" event
document.addEventListener("pagination:page-changed", async function (event) {

  // Pagination element 
  const $this = event.target;

  // URL to fetch
  const url = new URL(event.detail.href, window.location.origin);
  url.searchParams.set("section_id", $this.getAttribute("data-section-id"));

  // Data push selector
  const dataPushSelector = $this.getAttribute("data-push-selector");

  // Return if no push selector
  if (!dataPushSelector) {
    return;
  }

  try {
    // Fetch the new content from the server
    const response = await fetch(url.toString());

    // Check if the fetch was successful
    if (!response.ok) {
      throw new Error(`Error fetching content: ${response.statusText}`);
    }

    // Parse the response as text
    const responseAsText = await response.text();

    // Create a temporary div to load the HTML response
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = responseAsText;

    // Use querySelector to find the content in the fakeDiv
    let newContent = fakeDiv.querySelector(`#${dataPushSelector}`);

    if (dataPushSelector == 'tracklist-items') {
      newContent = fakeDiv.querySelector(`.tour-items`);
      if (newContent) {
        const targets = Array.from(document.querySelectorAll('.mata-track-list .tour-items'))

        targets.forEach(function (target) {
          target.innerHTML += newContent.innerHTML;
        })

        sortTrackList()
      }
    }
    else if (newContent) {
      // Article item visibility
      if (dataPushSelector == 'mata-article-list') {
        newContent.querySelectorAll(".article-item").forEach((item) => {
          item.style.opacity = 1;
        });
      }

      // Get the target element on the current page and replace its content
      const targetElement = document.getElementById(dataPushSelector);
      if (targetElement) {
        targetElement.innerHTML += newContent.innerHTML;

        // Sorting 
        if (dataPushSelector == 'tracklist-items') {
          // Sort Tracklist
          sortTrackList()
        } else if (dataPushSelector == 'discography-items') {
          // Sort Discography
          sortDiscography()

          // Activate the table manager
          new DiscographyTableFilter();
        }

      } else {
        // throw new Error(`Element with ID ${dataPushSelector} not found on the page.`);
      }


    } else {
      // throw new Error(`Element with ID ${dataPushSelector} not found in the fetched content.`);
    }

    // Update pagination__nav with new pagination link
    const newPaginationNav = fakeDiv.querySelector(".pagination__nav");
    if (newPaginationNav) {
      const paginationNavElement = $this.querySelector(".pagination__nav");
      if (paginationNavElement) {
        // Replace the old pagination__nav with the new one
        paginationNavElement.innerHTML = newPaginationNav.innerHTML;

        // Click newly added link
        if ($this.classList.contains("load-infinite-true")) {
          try {
            paginationNavElement.querySelector("a").click();
          } catch (error) {
            document.dispatchEvent(new CustomEvent("pagination:finished", { detail: { dataPushSelector } }));
          }
        }
      } else {
        // throw new Error(`.pagination__nav element not found in the current pagination area.`);
        // Register pagination finished event with dataPushSelector argument
        document.dispatchEvent(new CustomEvent("pagination:finished", { detail: { dataPushSelector } }));
      }
    } else {
      // Remove pagination__nav if there are no more pages
      $this.querySelector(".pagination__nav").remove();
      document.dispatchEvent(new CustomEvent("pagination:finished", { detail: { dataPushSelector } }));
    }

    // Article item visibility
    if (dataPushSelector == 'mata-article-list') {
      document.querySelectorAll(`#${dataPushSelector} > div`).forEach((item) => {
        item.classList.remove('hidden');
      });
    }

  } catch (e) {
    console.error("Error while fetching or updating pagination content:", e);
    // You can display an error message to the user if needed
  }
});


// Loaded Event
document.addEventListener("DOMContentLoaded", function () {
  // Find all "pagination__nav-item" elements inside "load-infinite-true"
  const loadMoreButtons = document.querySelectorAll(".load-infinite-true .pagination__nav-item");

  // Loop through all found buttons and click each one
  loadMoreButtons.forEach((button) => {
    button.click();
  });
});

// Sort Tracklist by ASC
const sortTrackList = () => {
  const lists = Array.from(document.querySelectorAll('.mata-track-list'))
  lists.forEach(function (list) {
    // Get the parent container
    const parent = list.querySelector(".tour-items");

    // Get all child elements with the class "tour-item"
    const items = Array.from(parent.querySelectorAll(".tour-item"));

    // Sort the items based on the "data-order" attribute
    items.sort((a, b) => {
      return parseInt(a.getAttribute("data-order")) - parseInt(b.getAttribute("data-order"));
    });

    // Remove the current items from the parent container
    parent.innerHTML = "";

    // Re-append the sorted items back into the parent container
    items.forEach(item => {
      parent.appendChild(item);
    });
  })
}

// Sort Discography by DESC
const sortDiscography = () => {
  // Get the parent container
  const parent = document.getElementById("discography-items");

  // Get all child elements with the class "tour-item"
  const items = Array.from(parent.querySelectorAll("tr"));

  // Sort the items based on the "data-order" attribute
  items.sort((a, b) => {
    return parseInt(b.getAttribute("data-order")) - parseInt(a.getAttribute("data-order"));
  });

  // Remove the current items from the parent container
  parent.innerHTML = "";

  // Re-append the sorted items back into the parent container
  items.forEach(item => {
    parent.appendChild(item);
  });

  // Set total items count
  new DiscographyTableFilter().totalItems();

  // Trigger event
  document.dispatchEvent(new CustomEvent("discography-sorted"));
}

// Discography Table Function
class DiscographyTableFilter {
  constructor(tableId = 'discography-items', searchInputClass) {
    this.table = document.getElementById(tableId);
    this.searchInput = document.querySelector(`.search-table`);
    this.resetBtn = document.querySelector(`.reset-filter`);
    this.rows = Array.from(this.table.querySelectorAll('tbody tr'));
    this.init();
  }

  init() {
    this.searchInput.addEventListener('input', () => this.handleSearch());

    // Reset filter
    this.resetBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.triggerSearch();
      }, 100);
    });
  }

  // Trigger Input
  triggerSearch() {
    document.querySelector(`.search-table`).dispatchEvent(new Event('input'));
  }

  // Set total visible items number
  totalItems() {
    // Get all table rows
    const rows = this.table.querySelectorAll('tr');

    // Filter the rows to only include visible ones
    const visibleRows = Array.from(rows).filter(row => row.style.display !== 'none');

    // Get the total number of visible rows
    const total_items = visibleRows.length;

    // Update the total in the DOM
    document.querySelector('.discography-display-total').innerHTML = total_items;
  }

  // Handle search
  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase(); // Get the search term

    this.rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      const match = Array.from(cells).some(cell =>
        cell.textContent.toLowerCase().includes(searchTerm)
      );
      row.style.display = match ? '' : 'none'; // Show or hide the row based on match
    });

    // Set total items count
    this.totalItems();
  }
}

// IP Location function
class MataIpLocation {
  constructor(cookieName = "user_country", cookieExpiryDays = 7) {
    this.cookieName = cookieName;
    this.cookieExpiryDays = cookieExpiryDays;
  }

  // Get Country
  getCountry() {
    const country = this.getCookie(this.cookieName);
    if (country && country !== "null") {
      return Promise.resolve(country);
    } else {
      return this.fetchCountryFromIpInfo().then((countryCode) => {
        const region = this.mapCountryToRegion(countryCode);
        this.setCountry(region);
        return region;
      });
    }
  }

  // Set Country
  setCountry(region) {
    this.setCookie(this.cookieName, region, this.cookieExpiryDays);
  }

  // Fetch country from ipinfo.io
  fetchCountryFromIpInfo() {
    return fetch("https://ipinfo.io/json")
      .then((response) => response.json())
      .then((data) => data.country)
      .catch((error) => {
        console.error("Failed to fetch country from IP info", error);
        return null;
      });
  }

  // Map country code to region
  mapCountryToRegion(countryCode) {
    const europeCountries = ["DE", "AT", "BE", "LU", "GR", "IE", "IT", "PT", "ES", "CH", "TR", "GB", "AI", "BM", "IO", "VG", "KY", "FK", "GI", "GG", "IM", "JE", "MS", "PN", "SH", "GS", "TC", "FR", "GF", "PF", "TF", "GP", "MQ", "YT", "NC", "RE", "BL", "MF", "PM", "WF", "NL", "CW", "SX", "FI", "IS", "SE", "DK", "FO", "GL", "NO", "BV", "SJ", "EE", "LV", "LT", "BG", "CZ", "HU", "PL", "MD", "RO", "SK", "AX", "AL", "AD", "BA", "HR", "CY", "VA", "XK", "LI", "MT", "MC", "ME", "SM", "RS", "SI", "MK"];

    if (europeCountries.includes(countryCode)) {
      return "Europe";
    }
    // Return the original country code if it's not Europe
    return countryCode;
  }

  // Utility methods for cookies
  setCookie(name, value, days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
      if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
  }
}


// Get Country on page loaded
document.addEventListener("DOMContentLoaded", async () => {
  const ipLocation = new MataIpLocation();
  const country = await ipLocation.getCountry();

  // Set href for Europe
  if (country && country === "Europe") {
    document.querySelectorAll('[data-uk_store_url]').forEach((el) => {
      el.href = el.getAttribute('data-uk_store_url');

      // Delete the attribute
      el.removeAttribute('data-uk_store_url');
    });
  }
});

// Pagination Finished Event
document.addEventListener("pagination:finished", async function (event) {
  // Get the dataPushSelector from the event details
  const dataPushSelector = event.detail.dataPushSelector;

  // Hide mata-track-list if no items
  if (dataPushSelector == 'tracklist-items') {
    const lists = Array.from(document.querySelectorAll('.mata-track-list'))
    lists.forEach(function (list) {
      if (list.querySelectorAll('.tour-item').length == 0) {
        list.classList.add('hidden');
      } else {
        let countMinWidth = 0;
        list.querySelectorAll('.tour-item-index').forEach((count) => {
          countMinWidth = count.offsetWidth > 0 ? count.offsetWidth : countMinWidth;
        });
        if (countMinWidth != 0) {
          list.querySelector('.tour-items').style.setProperty('--min-count-width', `${countMinWidth}px`);
        }
      }
    })
  } else if (dataPushSelector == 'discography-items') {
    if (document.querySelectorAll('#discography-items tr').length > 5) {
      document.querySelector('.discography-see-all')?.classList.remove('hidden');
    }
  }

  console.log(`Pagination finished for ${dataPushSelector}`);

});

// Discography Show All
document.querySelector('.discography-see-all')?.addEventListener('click', function () {
  document.getElementById('discography-items').classList.add('show-all-items');

  // Hide the button
  this.classList.add('hidden');
});

// Add click event listeners to each article-date-filter link
document.querySelectorAll('.article-date-filter')?.forEach(filterLink => {
  // Select the article list and archive container
  const articleList = document.querySelectorAll('#mata-article-list > div');

  filterLink.addEventListener('click', (event) => {
    event.preventDefault();

    const selectedDateKey = filterLink.getAttribute('date-key');

    // Remove the active class from all filters
    document.querySelectorAll('.article-date-filter').forEach(link => {
      link.classList.remove('current-link');
    });

    // Add active class to the clicked filter
    filterLink.classList.add('current-link');

    // Loop through each article and show or hide based on date-key match
    articleList.forEach(article => {
      if (article.getAttribute('data-date-key') === selectedDateKey) {
        article.classList.remove('hidden');
      } else {
        article.classList.add('hidden');
      }
    });

    // Hide Load More Pagination
    document.querySelector('.loadmore-blog-article')?.classList.add('hidden');
  });
});

// Load More articles
document.querySelector('.loadmore-blog-article')?.addEventListener('click', (event) => {
  event.preventDefault();

  // Select the article list and archive container
  let articleList = document.querySelectorAll('#mata-article-list > div[class*="hidden"]');

  // Show the next hidden articles
  articleList.forEach((article, index) => {
    if (index < 48) {
      article.classList.remove('hidden');
    }
  });

  // Hide button if no more hidden items
  let articleListLen = document.querySelectorAll('#mata-article-list > div[class*="hidden"]').length
  if (articleListLen == 0) {
    event.target.classList.add('hidden');
  }

});

// Product Recommendations Finish
document.addEventListener("recommendations:performed", async function (event) {
  // Instance
  const $this = event.detail.instance;

  // Current artist products
  let artistProducts = $this.getAttribute('data-artist-products');
  if (artistProducts) {
    artistProducts = JSON.parse(artistProducts);
  }

  // Display limit
  let displayLimit = $this.getAttribute('data-display-limit');

  // Performed Products
  $this.querySelectorAll('product-list [data-product-id]').forEach((product) => {
    const productId = parseInt(product.getAttribute('data-product-id'));

    // Hide if the product is in the artist products
    if (artistProducts && artistProducts.includes(productId)) {
      product.classList.add('hidden');
    } else {
      // Limit the number of products to display
      if (displayLimit && displayLimit > 0) {
        displayLimit--;
      } else {
        product.classList.add('lma-hidden', 'hidden');
      }
    }

  });

});
